import NewLabel from './NewLabel';

export default NewLabel;
